
import { defineComponent, reactive, Ref, ref, watch } from 'vue'

export default defineComponent({
    props: {
        loading: {
            type: Boolean,
            default: true,
            required: true,
        },
    },
    setup(props) {
        const state = reactive({
            fake_width: null as number | null,
        })

        const slot: Ref<HTMLElement | null> = ref(null)
        const slot_fake: Ref<HTMLElement | null> = ref(null)
        const slot_holder: Ref<HTMLElement | null> = ref(null)

        const onScroll = (e: any) => {
            if (slot_fake.value) {
                slot_fake.value.scrollLeft = e.target.scrollLeft
            }
        }

        const onScrollFake = (e: any) => {
            if (slot_holder.value) slot_holder.value.scrollLeft = e.target.scrollLeft
        }

        // Add top-scroll on window resize
        if (slot.value) {
            slot.value.addEventListener('resize', () => {
                if (slot.value) state.fake_width = slot.value.offsetWidth
            })
        }

        watch(
            () => props.loading,
            () => {
                if (slot.value && !props.loading) {
                    // Add top-scroll when table fethced some data
                    setTimeout(() => {
                        if (slot.value) state.fake_width = slot.value.offsetWidth
                    }, 100)
                }
            }
        )

        return {
            state,
            //
            slot,
            slot_fake,
            slot_holder,
            //
            onScroll,
            onScrollFake,
        }
    },
})
